export default __webpack_public_path__ + "static/media/shot4.6be5f0a8.jpg";